import { defineStore } from 'pinia';
import axios from '@/api/config/axios';

export const useUserStore = defineStore('userStore', {
    state: () => ({
        user: {
            config: {
                status_wpp: null,
                status_wpp_msg: null
            }
        }
    }),

    actions: {
        async getUser() {
            try {
                const response = await axios.get(`/api/v1/user`);

                if (response.data) {
                    this.user = response.data.data;
                } else {
                    console.error('Erro ao obter user');
                }

            } catch (error) {
                console.error('Erro ao tentar iniciar a conexão:', error);
            }
        },
        async salvarUser() {
            try {
                const response = await axios.post('/api/v1/completar-cadastro', this.user);
                return response.data;
            } catch (error) {
                console.error('Registration error:', error);
                throw error;
            }
        },
        async alterarSenha(dadosSenha) {
            try {
                const response = await axios.put('/api/v1/password', dadosSenha);
                return response.data;
            } catch (error) {
                console.error('Erro ao alterar senha:', error);
                throw error;
            }
        },
    },
});
